import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.747 9.999a.75.75 0 0 1 .75-.75H11.5a.75.75 0 0 1 0 1.5H5.497a.75.75 0 0 1-.75-.75M4.747 16.002a.75.75 0 0 1 .75-.75H11.5a.75.75 0 0 1 0 1.5H5.497a.75.75 0 0 1-.75-.75M5.497 12.25a.75.75 0 0 0 0 1.5H11.5a.75.75 0 1 0 0-1.5z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.999 2.246a1.75 1.75 0 0 0-1.75 1.75v2.252H3.997a1.75 1.75 0 0 0-1.75 1.75v12.256h-.251a.75.75 0 1 0 0 1.5h20.008a.75.75 0 1 0 0-1.5h-1.758v-1.587a3.25 3.25 0 0 0 2.508-3.165V13.5a3.25 3.25 0 0 0-2.5-3.162v-6.34a1.75 1.75 0 0 0-1.751-1.75zm9.747 18.008v-1.59a3.25 3.25 0 0 1-2.494-3.162V13.5a3.25 3.25 0 0 1 2.501-3.163v-6.34a.25.25 0 0 0-.25-.25H8.999a.25.25 0 0 0-.25.25v2.252H13c.967 0 1.75.783 1.75 1.75v12.256zm-5.495 0V7.998a.25.25 0 0 0-.25-.25H3.996a.25.25 0 0 0-.25.25v12.256h4.002v-1.251a.75.75 0 0 1 1.5 0v1.25zm8.003-4.752a1.75 1.75 0 0 1-1.745 1.75h-.021a1.75 1.75 0 0 1-1.736-1.75V13.5a1.75 1.75 0 0 1 3.502 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }